export default __webpack_public_path__ + "static/media/vid.1eaaf0d3.mp4";